import MenuSettings from 'client/components/core/Sidebar/components/Settings/entities/MenuSettings'
import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { libraryItems } from 'src/editor/layout/sidebar/library/library-items'
import { SettingsNestedMenu } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { Toggle } from 'src/editor/shared/ui-lib/toggle/toggle'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import { WebsiteHeaderInterface } from 'src/shared/types/website-entities'
import { WebsiteLogoSettings } from '../website-logo/website-logo-settings'
import { useElement } from './hooks/use-element'
import { getToggleConfigItems } from './utils'
import { WebsiteHeaderLibraryElement } from './website-header-library-element'

interface WebsiteHeaderElementsProps {
  entity: WebsiteHeaderInterface
}

export const WebsiteHeaderElements = ({
  entity,
}: WebsiteHeaderElementsProps) => {
  const { toggleElement, getToggleValue } = useElement({ entity })
  const { t } = useTranslation()
  const toggleConfig = getToggleConfigItems()

  const websiteLogoEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.childIds[0]),
  )
  const menuEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.childIds[1]),
  )

  const isLogoEntity =
    websiteLogoEntity && websiteLogoEntity.type === EntityTypeEnum.WebsiteLogo
  const isMenuEntity = menuEntity && menuEntity.type === EntityTypeEnum.Menu

  return (
    <div className="flex flex-col gap-2">
      {isMenuEntity && (
        <SettingsNestedMenu
          menuTitle={t(libraryItems[LibraryElementEnum.LibraryMenu]?.title)}
          menuButtonClassName="p-0 mb-2"
          menuButtonLabel={
            <WebsiteHeaderLibraryElement
              libraryElement={LibraryElementEnum.LibraryMenu}
            />
          }
        >
          <MenuSettings entity={menuEntity as MenuInterface} />
        </SettingsNestedMenu>
      )}
      {isLogoEntity && (
        <SettingsNestedMenu
          menuTitle={t(
            libraryItems[LibraryElementEnum.LibraryWebsiteLogo]?.title,
          )}
          menuButtonClassName="p-0"
          menuButtonLabel={
            <WebsiteHeaderLibraryElement
              libraryElement={LibraryElementEnum.LibraryWebsiteLogo}
            />
          }
        >
          <WebsiteLogoSettings
            entity={websiteLogoEntity as WebsiteLogoInterface}
          />
        </SettingsNestedMenu>
      )}

      <div className="mt-1 mb-1 h-[1px] w-full bg-bgTertiary"></div>

      {toggleConfig.map(el => (
        <Toggle
          key={el}
          onChange={value => toggleElement(value, el)}
          checked={getToggleValue(el)}
          labelClassName="justify-between w-full"
          startElement={<WebsiteHeaderLibraryElement libraryElement={el} />}
        />
      ))}
    </div>
  )
}
